<template>
  <div>{{ title }}</div>
</template>

<script>
export default {
  name: 'RecruiterIcoCriteriaResultTypeSelectOne',
  props: {
    jobQuestion: {
      type: Object,
      required: true,
    },
    variable: {
      type: Object,
      required: true,
    }
  },
  computed: {
    title: function () {
      return this.variable.short_label || this.variable.input_label;
    },
  },
};
</script>

<style scoped />
